/**
 * Offline Indicator Directive
 * Shows connection status
 */
(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('offlineIndicator', offlineIndicator);

    offlineIndicator.$inject = ['$timeout', 'pwaSvc'];

    function offlineIndicator($timeout, pwaSvc) {
        return {
            restrict: 'E',
            template: `
                <div class="pwa-offline-indicator" ng-class="{online: isOnline, 'pwa-show': !isOnline}">
                    <span class="status-dot"></span>
                    <span ng-if="!isOnline">Çevrimdışı</span>
                    <span ng-if="isOnline">Çevrimiçi</span>
                </div>
            `,
            link: function (scope, element, attrs) {
                scope.isOnline = pwaSvc.isOnline;

                // Listen for online/offline events
                scope.$on('pwa:online', function () {
                    scope.isOnline = true;

                    // Auto-hide after 3 seconds when back online
                    $timeout(function () {
                        element.find('.pwa-offline-indicator').removeClass('pwa-show');
                    }, 3000);
                });

                scope.$on('pwa:offline', function () {
                    scope.isOnline = false;
                });
            }
        };
    }
})();
